import { IModuleInitializerParams } from "@/Common/Modularity/ModuleInitializer";
import { ModuleInitializerBuilder } from "@/Common/Modularity/ModuleInitializerBuilder";
import { ModuleNames } from "../ModuleNames";

function isFeatureFlagEnabled(params: IModuleInitializerParams): boolean {
    return params.clinicSettings.EnableBasicInstantMessaging || params.clinicSettings.EnableInstantMessaging;
}

function shouldLoadInstantMessagingModule(params: IModuleInitializerParams): boolean {
    return isFeatureFlagEnabled(params);
}

const initializeInstantMessaging = new ModuleInitializerBuilder()
    .withConditionalLoading(shouldLoadInstantMessagingModule)
    .build(ModuleNames.InstantMessaging, async () => (await import("./InstantMessagingModule")).default);

export default initializeInstantMessaging;
